/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import moment from 'moment';

// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Col,
  Input,
  Button,
  Spinner,
} from 'reactstrap';
// core components
import Header from 'components/Headers/Header.js';
import { axiosGet } from 'util/apiConfig.js';
import { databaseDateTimeFormat, dateForPaymentListing } from 'util/constance';
import { accountLabel } from 'util/constants';
import Select from "react-select";

class PaymentListing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentListingData: [],
      page: 1,
      totalPage: 0,
      lastItemId: null,
      firstItemId: null,
      classList: [],
      limit: 10,
      total: 0,
      category: 'all',
      searchValue: '',
      loading: false,
    };
  }

  componentDidMount() {
    this.setState(
      {
        paymentListingData: [],
        classList: [],
      },
      () => {
        this.getPaymentListingData();
      }
    );
  }

  getClass = () => {
    // API --
    axiosGet(`class/get-classes-list`)
        .then((response) => {
          if (!response.isError) {
            // this.getNotificationMessage(response.data[0].classId);
            this.setState({
              classList: response.data || [],
              classId: response.data[0].classId,
            },()=> {
              this.getPaymentListingData()
            });
          } else {
            this.setState({
              classList: [],
            });
          }
        })
        .catch((error) => {
          this.setState({
            classList: [],
          });
        });
  };

  // for getting all approved student -
  getPaymentListingData = (startingAfter = null, endingBefore = null) => {
    const { page, category, searchValue } = this.state;
    let url = `payment/get-active-subscriptions/${page}/?category=${category}&`;
    if (searchValue) url = url + `search=${searchValue}&`;
    if (startingAfter) url = url + `startingAfter=${startingAfter}&`;
    if (endingBefore) url = url + `endingBefore=${endingBefore}&`;

    this.setState({ loading: true });
    axiosGet(url)
      .then((response) => {
        if (!response.isError) {
          const result = response.data?.result || [];
          this.setState({
            paymentListingData: result,
            total: response.data.total,
            totalPage: response.data?.noofpage,
            lastItemId: result.length > 0 ? result[result.length - 1].id : null,
            firstItemId: result.length > 0 ? result[0].id : null,
            loading: false,
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
      });
  };

  // For changing page -
  changePage = (status) => {
    const {lastItemId, firstItemId} = this.state
    if (status && status === 'next') {
      this.setState({ page: this.state.page + 1 }, () =>
        this.getPaymentListingData(lastItemId)
      );
    } else if (status && status === 'prev') {
      this.setState({ page: this.state.page - 1 }, () =>
        this.getPaymentListingData(null, firstItemId)
      );
    }
  };

  render() {
    let { paymentListingData, page, totalPage, total, classList, classId } = this.state;
    return (
      <>
        <Header />
        {/* Page content */}
        <Container className='mt--7' fluid>
          {/* Table */}
          <Row>
            <div className='col'>
              <Card className='shadow'>
                <CardHeader className='border-0'>
                  <h3 className='mb-0'>Active Subscription</h3>
                  <Row className="mt-3">
                    <Col md="4">
                      <Input
                        placeholder="Search by name or email"
                        type="text"
                        value={this.state.searchValue}
                        onChange={(e) => {
                          this.setState({ searchValue: e.target.value });
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            this.setState({ page: 1 }, () => this.getPaymentListingData());
                          }
                        }}
                      />
                    </Col>
                    <Col md="3">
                      <Select
                        options={[
                          { value: 'all', label: 'All Categories' },
                          { value: 'Chess', label: 'Chess' },
                          { value: 'Maths', label: 'Maths' },
                          { value: 'Code', label: 'Code' },
                          { value: 'SpeakClub', label: 'ELA Club' },
                        ]}
                        value={{
                          value: this.state.category,
                          label: this.state.category === 'all' ? 'All Categories' : accountLabel(this.state.category)
                        }}
                        placeholder="Select Category"
                        onChange={(e) => {
                          this.setState({ category: e.value, page: 1 }, () => {
                            this.getPaymentListingData();
                          });
                        }}
                      />
                    </Col>
                    <Col md="2">
                      <Button color="primary" onClick={() => {
                        this.setState({ page: 1 }, () => this.getPaymentListingData());
                      }}>
                        Search
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <Table className='align-items-center table-flush' responsive>
                  <thead className='thead-light'>
                    <tr>
                      <th scope='col'>User Name</th>
                      <th scope='col'>Email</th>
                      <th scope='col'>Plan</th>
                      <th scope='col'>Account</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.loading ? (
                      <tr>
                        <td colSpan="4" className="text-center py-4">
                          <Spinner color="primary" />
                          <p className="mt-2">Loading subscriptions...</p>
                        </td>
                      </tr>
                    ) : paymentListingData?.length > 0 ? (
                      paymentListingData.map((data, index) => {
                        return (
                          <tr key={index}>
                            <td>{data?.customer?.name || ''}</td>
                            <td>{data?.customer?.email || ''}</td>
                            <td>{data?.plan?.nickname || ''}</td>
                            <td>
                              <span className="badge badge-dot mr-4">
                                <i className={
                                  data.account === 'Chess' ? 'bg-info' :
                                  data.account === 'Maths' ? 'bg-success' :
                                  data.account === 'Code' ? 'bg-warning' :
                                  data.account === 'SpeakClub' ? 'bg-danger' : 'bg-primary'
                                } />
                                <span className="status">{accountLabel(data.account) || 'N/A'}</span>
                              </span>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center py-4">
                          No active subscriptions found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                <CardFooter className='py-4'>
                  <nav aria-label='...'>
                    <Pagination
                      className='pagination justify-content-end mb-0'
                      listClassName='justify-content-end mb-0'
                    >
                      <PaginationItem
                          className={page > 1 ? '' : 'disabled'}>
                        <PaginationLink
                          onClick={() => this.changePage('prev')}
                          tabIndex='-1'
                        >
                          <i className='fas fa-angle-left' />
                          <span className='sr-only'>Previous</span>
                        </PaginationLink>
                      </PaginationItem>

                      <PaginationItem className='active'>
                        <PaginationLink onClick={(e) => e.preventDefault()}>
                          {page}
                        </PaginationLink>
                      </PaginationItem>

                      <PaginationItem
                        className={total < 100 ? 'disabled' : ''}
                      >
                        <PaginationLink onClick={() => this.changePage('next')}>
                          <i className='fas fa-angle-right' />
                          <span className='sr-only'>Next</span>
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default PaymentListing;
